<ng-container *ngIf="isOpen; else isClosed">
	<div class="open">
		<form [formGroup]="form" class="content-container">
			<div class="row">
				<div class="col-6">
					<div class="ref">Ref.: {{indicator?.refCode}}</div>
					<span class="description">{{indicator?.name}}&nbsp;</span>
					<mat-icon #tooltip="matTooltip" *ngIf="indicator?.description" [matTooltipHideDelay]="300"
						class="tooltip-info" matTooltip="{{indicator?.description}}" matTooltipClass="white-tooltip"
						matTooltipPosition="above">error
					</mat-icon>
				</div>
				<div class="col-auto">
					<div class="status-label">STATUS</div>
					<div class="status-container" [ngStyle]="{
						'background-color': getColorStatus(indicator?.indicatorInfo.status)
					}">
						<span [translate]="'city-profile-certification/indicator/status/' + indicator?.indicatorInfo.status"></span>
					</div>
				</div>
			</div>
			<div class="gray-content-container">
				<div class="row">
					<div class="col-md-6 col-12">
						<div (click)="downloadModel()" *ngIf="!!indicator.evidenceModelUrl" class="col-md-auto btn-container-model">
							<button mat-stroked-button>
								<i class="fal fa-file-word-o"></i>
								{{ "city-profile-certification/indicator/button-model" | translate }}
							</button>
						</div>

						<div class="row mb-4">
							<div *ngIf="hasNumeratorAndDenominator" class="col-12 col-md-6 cert-input-value">
								<mat-form-field style="width: 100%;">
									<mat-label [translate]="'city-profile-certification/indicator/numerator'"></mat-label>
									<input formControlName="numerator" inputMask inputMaskType="NUMBER" matInput>
								</mat-form-field>
							</div>
							<div *ngIf="hasNumeratorAndDenominator" class="col-12 col-md-6 cert-input-value">
								<mat-form-field style="width: 100%;">
									<mat-label [translate]="'city-profile-certification/indicator/denominator'"></mat-label>
									<input formControlName="denominator" inputMask inputMaskType="NUMBER" matInput>
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-12 cert-input-value">
								<mat-form-field style="width: 100%;">
									<mat-label [translate]="'city-profile-certification/indicator/value'"></mat-label>
									<input [inputMaskType]="indicator?.validationType" formControlName="value" inputMask matInput>
									<div matSuffix>{{indicator?.unity}}</div>
								</mat-form-field>
							</div>
						</div>
						<div class="row mb-3">
							<div class="col-12 formula">
								<i class="far fa-calculator"></i>
								<span [translate]="'city-profile-certification/indicator/formula'" class="ml-1 label"></span>
								<span class="ml-1 value">{{indicator?.formula}}</span>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<mat-form-field style="width: 100%;">
									<mat-label [translate]="'city-profile-certification/indicator/more-information'"></mat-label>
									<textarea formControlName="moreInformation" matInput rows="4"></textarea>
								</mat-form-field>
							</div>
						</div>
						<ng-container *ngIf="indicator?.indicatorInfo?.ncDescription">
							<div class="row mt-5">
								<div class="col-12">
									<div class="iso-consideration-container">
										<div class="iso-consideration-label"
											[translate]="'city-profile-certification/indicator/iso-considerations'"></div>
											<div class="iso-consideration-content mt-3" [innerHTML]="indicator?.indicatorInfo?.ncDescription">
											</div>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
					<div class="col-md-6 col-12">
						<label [translate]="'city-profile-certification/indicator/attach-file'" class="label-file"></label>
						<div class="attach-file-container">
							<div class="row align-items-center mb-3">
								<div class="col-auto attach-file-button">
									<button mat-stroked-button (click)="openDialogAttachEvidence('DOCUMENT')">
										<i class="fal fa-file-pdf mr-2"></i>
										<span [translate]="'city-profile-certification/indicator/attach-pdf'"></span>
									</button>
								</div>
								<div class="col-auto attach-file-button-label">
									<span [translate]="'city-profile-certification/indicator/only-pdf'">Formato permitido apenas
										PDF</span>
								</div>
							</div>
							<mat-divider></mat-divider>
							<div class="row mt-3">
								<div class="col-auto attach-file-list-label">
									<span [translate]="'city-profile-certification/indicator/attached-files'"></span>
								</div>
							</div>
							<div class="row mt-3">
								<ng-container *ngFor="let evidence of documentEvidenceList()">
									<div class="col-12">
										<div class="attach-file-list px-2">
											<div class="row align-items-center justify-content-between">
												<div class="col-auto attach-file-list-name">
													<span>{{evidence.originalFileName}}</span>
												</div>
												<div class="col-auto">
													<div class="row justify-content-end">
														<div class="col-auto px-0 attach-file-list-description">
															<button mat-button (click)="openReviewFile(evidence)">
																<i class="fal fa-comment-lines me-2"></i>
																<span [translate]="'city-profile-certification/indicator/view-description'"></span>
															</button>
														</div>
														<div class="col-auto ps-0 attach-file-list-delete">
															<button mat-icon-button (click)="handleRemoveEvidence(evidence.evidenceId)">
																<i class="fal fa-trash-alt"></i>
															</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</ng-container>
							</div>
						</div>
						<div class="attach-file-container mt-3">
							<div class="row align-items-center mb-3">
								<div class="col-auto attach-file-button">
									<button mat-stroked-button (click)="openDialogAttachEvidence('LINK')">
										<i class="fal fa-link mr-2"></i>
										<span [translate]="'city-profile-certification/indicator/attach-link'"></span>
									</button>
								</div>
								<div class="col-auto attach-file-button-label">
									<span [translate]="'city-profile-certification/indicator/attach-link-for-evidence'"></span>
								</div>
							</div>
							<mat-divider></mat-divider>
							<div class="row mt-3">
								<div class="col-auto attach-file-list-label">
									<span [translate]="'city-profile-certification/indicator/attached-links'"></span>
								</div>
							</div>
							<div class="row mt-3">
								<ng-container *ngFor="let evidence of linkEvidenceList()">
									<div class="col-12">
										<div class="attach-file-list px-2">
											<div class="row align-items-center justify-content-between">
												<div class="col-auto attach-file-list-name">
													<span>{{evidence.link}}</span>
												</div>
												<div class="col-auto">
													<div class="row justify-content-end">
														<div class="col-auto px-0 attach-file-list-description">
															<button mat-button (click)="openReviewLink(evidence)">
																<i class="fal fa-comment-lines me-2"></i>
																<span [translate]="'city-profile-certification/indicator/view-description'"></span>
															</button>
														</div>
														<div class="col-auto ps-0 attach-file-list-delete">
															<button mat-icon-button (click)="handleRemoveEvidence(evidence.evidenceId)">
																<i class="fal fa-trash-alt"></i>
															</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</ng-container>
							</div>
						</div>
						<!-- <div>
							<div (fileOver)="fileOver($event)" [ngClass]="{'has-file': hasFile}" [uploader]="uploader"
									 class="ng2FileDrop file-drop" ng2FileDrop>
								<i class="icon fal fa-upload"></i>
								<em [translate]="'city-profile-certification/indicator/drag-drop'">Drag and drop the image here</em>
								<span class="button">
                <span [translate]="'city-profile-certification/indicator/select-file'">CHOOSE PHOTO</span>
                <input [uploader]="uploader" id="imageUrl" ng2FileSelect type="file"/>
              </span>
							</div>
							<div class="text-info-upload ml-0">
								<span [translate]="'city-profile-certification/indicator/max-file-size'">Maximum file size:</span> 4MB
							</div>
						</div>

						<div *ngIf="loadingFile" class="loading-file mt-2 row justify-content-between">
							<div [translate]="'city-profile-certification/indicator/loading'" class="col-auto progress-label"></div>
							<div class="col custom-bar">
								<mat-progress-bar [value]="progressFile" mode="determinate">
								</mat-progress-bar>
							</div>
							<div class="col-auto progress-value">
								{{progressFile}}%
							</div>
						</div>

						<div cdkDropListGroup class="thumbs mt-2">
							<div (cdkDropListDropped)="drop($event)"
									 (click)="showEvidence(evidence)" *ngFor="let evidence of evidences.controls; let i = index"
									 [cdkDropListData]="{ item: evidence, index: i }" cdkDropList
									 cdkDropListOrientation="horizontal"
									 class="thumb-drop-list row justify-content-between mt-2 clickable">
								<div cdkDrag class="thumb-drag col-auto">
									<ng-container *ngIf="fileType(evidence.value.type, 'image')">
										<div class="thumb-preview">
											<i class="fal fa-image"></i>
										</div>
									</ng-container>
									<ng-container *ngIf="fileType(evidence.value.type, 'video')">
										<div class="thumb-preview">
											<i class="fal fa-play"></i>
										</div>
									</ng-container>
									<ng-container *ngIf="fileType(evidence.value.type, 'pdf')">
										<div class="thumb-preview">
											<i class="fal fa-file-alt"></i>
										</div>
									</ng-container>
								</div>
								<div class="col thumb-name">
									{{evidence.value.originalFileName}}</div>
								<div (click)="removeUpload(i)" class="col-auto remove-upload ml-2">
									<i class="fal fa-trash-alt"></i>
								</div>
							</div>
						</div>
						<mat-divider class="my-3"></mat-divider>
						<div cdkDropListGroup class="thumbs">
							<div (click)="goToLink(link.value)"
									 *ngFor="let link of links.controls; let i = index"
									 class="thumb-drop-list row justify-content-between mt-2 clickable">
								<div class="thumb-drag col-auto">
									<div class="thumb-preview">
										<i class="fal fa-link"></i>
									</div>
								</div>
								<div class="col thumb-name">
									{{link.value}}</div>
								<div (click)="removeLink(i)" class="col-auto remove-upload ml-2">
									<i class="fal fa-trash-alt"></i>
								</div>
							</div>
						</div>
						<div class="row mt-3">
							<div class="col">
								<button (click)="addLink()" mat-button>
									<i class="fal fa-link mr-2"></i>
									Incluir link
								</button>
							</div>
						</div> -->
					</div>
				</div>
				<div *ngIf="!hasData" class="row justify-content-end mt-2">
					<div class="col-md-auto btn-container-cancel">
						<button (click)="toggleOpen(); clearForm()" mat-flat-button>
							<span [translate]="'city-profile-certification/indicator/cancel'"></span>
						</button>
					</div>
					<div class="col-md-auto btn-container">
						<button (click)="submit()" mat-flat-button>
							<span [translate]="'city-profile-certification/indicator/save'"></span>
						</button>
					</div>
				</div>
				<div *ngIf="hasData" class="row justify-content-end mt-2">
					<div class="col-md-auto btn-container-cancel">
						<button (click)="toggleOpen(); toggleEnableForm(); clearForm()" mat-flat-button>
							<span [translate]="'city-profile-certification/indicator/cancel'">Cancelar</span>
						</button>
					</div>
					<div class="col-md-auto btn-container">
						<button (click)="submit()" mat-flat-button>
							<span [translate]="'city-profile-certification/indicator/save'">Salvar</span>
						</button>
					</div>
				</div>
			</div>
		</form>
		<div *ngIf="isMain" class="main"></div>
	</div>
</ng-container>
<ng-template #isClosed>
	<ng-container *ngIf="hasData">
		<div class="closed with-data">
			<form [formGroup]="form">
				<div class="row mb-3">
					<div class="col-6">
						<div class="ref">Ref.: {{indicator?.refCode}}</div>
						<div class="description">{{indicator?.name}}</div>
					</div>
					<div class="col-auto">
						<div class="status-label">STATUS</div>
						<div class="status-container" [ngStyle]="{
							'background-color': getColorStatus(indicator?.indicatorInfo.status)
						}">
							<span
								[translate]="'city-profile-certification/indicator/status/' + indicator?.indicatorInfo.status"></span>
						</div>
					</div>
				</div>
				<div class="row content">
					<div class="col-md-6 col-12">
						<div class="row">
							<div *ngIf="hasNumeratorAndDenominator" class="col-12 col-md-6">
								<mat-form-field style="width: 100%;">
									<mat-label [translate]="'city-profile-certification/indicator/numerator'">Numerador</mat-label>
									<input formControlName="numerator" matInput type="text">
								</mat-form-field>
							</div>
							<div *ngIf="hasNumeratorAndDenominator" class="col-12 col-md-6">
								<mat-form-field style="width: 100%;">
									<mat-label [translate]="'city-profile-certification/indicator/denominator'">Denominador</mat-label>
									<input formControlName="denominator" matInput type="text">
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<mat-form-field style="width: 100%;">
									<mat-label [translate]="'city-profile-certification/indicator/value'">Valor</mat-label>
									<input formControlName="value" matInput type="text">
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-12 formula">
								<i class="far fa-calculator"></i>
								<span [translate]="'city-profile-certification/indicator/formula'" class="ml-1 label">FÓRMULA:</span>
								<span class="ml-1 value">{{indicator?.formula}}</span>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<mat-form-field style="width: 100%;">
									<mat-label [translate]="'city-profile-certification/indicator/more-information'"></mat-label>
									<textarea formControlName="moreInformation" matInput rows="4"></textarea>
								</mat-form-field>
							</div>
						</div>

						<ng-container *ngIf="indicator?.indicatorInfo?.ncDescription">
							<div class="row mt-3">
								<div class="col-12">
									<div class="iso-consideration-container">
										<div class="iso-consideration-label"
											[translate]="'city-profile-certification/indicator/iso-considerations'"></div>
										<div class="iso-consideration-content mt-3" [innerHTML]="indicator?.indicatorInfo?.ncDescription">
										</div>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
					<div class="col-md-6 col-12">
						<label [translate]="'city-profile-certification/indicator/attach-file'" class="label-file"></label>
						<div class="attach-file-container">
							<div class="row align-items-center mb-3">
								<div class="col-auto attach-file-button-readonly">
									<button mat-stroked-button disabled>
										<i class="fal fa-file-pdf mr-2"></i>
										<span [translate]="'city-profile-certification/indicator/attach-pdf'"></span>
									</button>
								</div>
								<div class="col-auto attach-file-button-label">
									<span [translate]="'city-profile-certification/indicator/only-pdf'">Formato permitido apenas
										PDF</span>
								</div>
							</div>
							<mat-divider></mat-divider>
							<div class="row mt-3">
								<div class="col-auto attach-file-list-label">
									<span [translate]="'city-profile-certification/indicator/attached-files'"></span>
								</div>
							</div>
							<div class="row mt-3">
								<ng-container *ngFor="let evidence of documentEvidenceList()">
									<div class="col-12">
										<div class="attach-file-list px-2">
											<div class="row align-items-center justify-content-between">
												<div class="col-auto attach-file-list-name-readonly">
													<span>{{evidence.originalFileName}}</span>
												</div>
												<div class="col-auto">
													<div class="row justify-content-end">
														<div class="col-auto px-0 attach-file-list-description">
															<button mat-button (click)="openReviewFile(evidence)">
																<i class="fal fa-comment-lines me-2"></i>
																<span [translate]="'city-profile-certification/indicator/view-description'"></span>
															</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</ng-container>
							</div>
						</div>
						<div class="attach-file-container mt-3">
							<div class="row align-items-center mb-3">
								<div class="col-auto attach-file-button-readonly">
									<button mat-stroked-button disabled>
										<i class="fal fa-link mr-2"></i>
										<span [translate]="'city-profile-certification/indicator/attach-link'"></span>
									</button>
								</div>
								<div class="col-auto attach-file-button-label">
									<span [translate]="'city-profile-certification/indicator/attach-link-for-evidence'"></span>
								</div>
							</div>
							<mat-divider></mat-divider>
							<div class="row mt-3">
								<div class="col-auto attach-file-list-label">
									<span [translate]="'city-profile-certification/indicator/attached-links'"></span>
								</div>
							</div>
							<div class="row mt-3">
								<ng-container *ngFor="let evidence of linkEvidenceList()">
									<div class="col-12">
										<div class="attach-file-list px-2">
											<div class="row align-items-center justify-content-between">
												<div class="col-auto attach-file-list-name-readonly">
													<span>{{evidence.link}}</span>
												</div>
												<div class="col-auto">
													<div class="row justify-content-end">
														<div class="col-auto px-0 attach-file-list-description">
															<button mat-button (click)="openReviewLink(evidence)">
																<i class="fal fa-comment-lines me-2"></i>
																<span [translate]="'city-profile-certification/indicator/view-description'"></span>
															</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</ng-container>
							</div>
						</div>
						<!-- <label [translate]="'city-profile-certification/indicator/attach-file'" class="label-file">ANEXAR
							EVIDÊNCIAS</label>
						<div cdkDropListGroup class="thumbs mt-2">
							<div (cdkDropListDropped)="drop($event)" (click)="showEvidence(evidence)"
								*ngFor="let evidence of evidences.controls; let i = index"
								[cdkDropListData]="{ item: evidence, index: i }" cdkDropList cdkDropListOrientation="horizontal"
								class="thumb-drop-list row justify-content-between mt-2 clickable">
								<div cdkDrag class="thumb-drag col-auto">
									<ng-container *ngIf="fileType(evidence.value.type, 'image')">
										<div class="thumb-preview">
											<i class="fal fa-image"></i>
										</div>
									</ng-container>
									<ng-container *ngIf="fileType(evidence.value.type, 'video')">
										<div class="thumb-preview">
											<i class="fal fa-play"></i>
										</div>
									</ng-container>
									<ng-container *ngIf="fileType(evidence.value.type, 'pdf')">
										<div class="thumb-preview">
											<i class="fal fa-file-alt"></i>
										</div>
									</ng-container>
								</div>
								<div class="col thumb-name">{{evidence.value.originalFileName}}</div>
							</div>
						</div>
						<mat-divider class="my-3"></mat-divider>
						<div cdkDropListGroup class="thumbs">
							<div (click)="goToLink(link.value)" *ngFor="let link of links.controls; let i = index"
								class="thumb-drop-list row justify-content-between mt-2 clickable">
								<div class="thumb-drag col-auto">
									<div class="thumb-preview">
										<i class="fal fa-link"></i>
									</div>
								</div>
								<div class="col thumb-name">
									{{link.value}}</div>
							</div>
						</div> -->
					</div>
				</div>
				<div class="row justify-content-end mt-2" *ngIf="indicator?.indicatorInfo.status === 'IN_FILLING' || indicator?.indicatorInfo.status === 'WAITING'">
					<div class="col-md-auto btn-container-closed">
						<button (click)="toggleOpen(); toggleEnableForm()" mat-flat-button>
							<span [translate]="'city-profile-certification/indicator/edit'"></span>
						</button>
					</div>
				</div>
			</form>
			<div *ngIf="isMain" class="main"></div>
		</div>
	</ng-container>
	<ng-container *ngIf="!hasData">
		<div class="closed">
			<div class="row">
				<div class="col-md-10 col-12">
					<div class="ref">Ref.: {{indicator?.refCode}}</div>
					<div class="description">{{indicator?.name}}</div>
				</div>
				<div class="col-md-2 col-12 btn-container">
					<button (click)="toggleOpen();" mat-stroked-button>
						<span [translate]="'city-profile-certification/indicator/answer'">RESPONDER</span>
					</button>
				</div>
			</div>
			<div *ngIf="isMain" class="main"></div>
		</div>
	</ng-container>
</ng-template>